<template>
  <div class="EmailInput">
    <TextInput
      :id="$attrs.id || 'email'"
      ref="emailInput"
      v-bind="$attrs"
      :class="$attrs.class || 'field required'"
      :name="$attrs.name || 'email'"
      :label="$attrs.label || 'E-mail'"
      :placeholder="$attrs.placeholder || 'email@exemplo.com.br'"
      :validations="
        $attrs.validations || 'required|rgx:email|validateEmailDomain'
      "
      @input="($emit('input', $event), getSuggestion($event))"
      @blur="$emit('blur', $event)"
    >
      <template #external-message>
        <slot name="external-message" />
      </template>
    </TextInput>
    <div v-if="cptdDomains.length > 0 || emailSugg" class="email-helpers">
      <div v-if="cptdDomains.length > 0" class="domains">
        <Button
          v-for="domain in cptdDomains"
          :key="domain"
          size="small"
          type="outlined"
          @click="setEmailDomain(domain)"
        >
          {{ domain }}
        </Button>
      </div>
      <p v-if="emailSugg" class="suggestion">
        Você quis dizer <span @click="setEmailSugg">{{ emailSugg }}</span
        >?
      </p>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import suggest from 'email-domain-levenshtein'
import TextInput from '@/components/ui/newComponents/TextInput.vue'
import Button from '@/aasgard/components/buttons/Button.vue'
export default {
  name: 'EmailInput',
  components: {
    Button,
    TextInput,
  },
  inheritAttrs: false,
  emits: ['blur', 'input'],
  data() {
    return {
      emailSugg: '',
      focused: false,
    }
  },
  computed: {
    cptdDomains() {
      if (!this.$attrs?.modelValue || !this.$attrs?.modelValue.includes('@'))
        return []

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [_, domain] = (this.$attrs?.modelValue ?? '').split('@')
      const mainDomains = [
        '@gmail.com',
        '@hotmail.com',
        '@outlook.com',
        '@icloud.com',
      ]

      return mainDomains.filter(
        (d) => d.includes(domain ?? '') && d !== '@' + domain,
      )
    },
  },
  mounted() {
    this.actEmitGaEvent({
      eventCategory: 'email-input',
      eventAction: 'field-displayed',
      eventLabel: 'field-displayed',
    })
    if (this.$attrs?.modelValue) {
      this.getSuggestion(this.$attrs?.modelValue)
    }
  },
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
    }),
    setEmailDomain(domain) {
      const [left] = (this.$attrs?.modelValue ?? '').split('@')
      this.$refs.emailInput.handleChange(left + domain)
      this.emailSugg = ''
      this.actEmitGaEvent({
        eventCategory: 'email-input',
        eventAction: 'click-domain-badge',
        eventLabel: 'click-domain-badge',
      })
    },
    setEmailSugg() {
      this.$refs.emailInput.handleChange(this.emailSugg)
      this.emailSugg = ''
      this.actEmitGaEvent({
        eventCategory: 'email-input',
        eventAction: 'click-suggestion',
        eventLabel: 'click-suggestion',
      })
    },
    getSuggestion(value) {
      const [left, domain] = value.split('@')
      if (left && domain) {
        const suggestion = suggest(value)
        this.emailSugg = suggestion !== value ? suggestion : ''
      } else {
        this.emailSugg = ''
      }
    },
  },
}
</script>
<style lang="scss">
.EmailInput {
  & > .email-helpers {
    margin: -8px 0 24px 0;
    & > .domains {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 4px;
      margin: 0 0 16px 0;

      & > .Button {
        @include caption;
        padding: 0;
        height: 24px;
      }
    }
    .suggestion {
      @include caption;
      color: $color-black-high;
      margin: 0;

      span {
        color: $color-brand-primary;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}
</style>
